module.exports = __webpack_public_path__ + "img/slider_galery_26.fec26bc4.jpg";